// extracted by mini-css-extract-plugin
export default {"ArrowMenu":"styles_ArrowMenu__ZHxwz","options":"styles_options__Fs8sL","lastItemLine":"styles_lastItemLine__YWc63","disabled":"styles_disabled__YmlXK"};